import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=28f6b212&scoped=true&"
import script from "./PrescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=28f6b212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6b212",
  null
  
)

export default component.exports